import React from 'react';
import Notibar from './Notibar';

const Coverflow = () =>{
    return(
        <div className="screen-wrapper">
            <div className="screen-internal-wrapper white">
                <Notibar/>
                
                <div><h1>Coverflow</h1></div>
            </div>
        </div>
    );
}
export default Coverflow;